<template>
  <div class="off-detail">
    <div class="off-detail-main">
      <div style="font-weight:900;font-size:16px">阅读游戏账号注销条件</div>
      <div style="font-weight:900;font-size:16px">并在页面底部勾选确认</div>
      <p style="font-size:14px;font-family:FZLTHK--GBK1-0">《游戏账号注销条件》</p>
    <p style="font-size:14px;font-family:FZLTHK--GBK1-0">
      尊敬的用户，在您正式开始下一步有关本游戏的游戏账号注销流程前，请您务必先行仔细阅读和充分理解《游戏账号注销协议》(“本协议”) ，并按照我们的注销流程进行操作，您勾选本注销协议并开始下一步操作的，视为您已经同意和遵守本协议全部内容。我们在此特别提示您: 
        </p>
    <p style="font-size:14px;font-family:FZLTHK--GBK1-0">注销本游戏账号后，除法律法规及游戏账号注销协议另有规定外，基于该账号的信息相关数据也将进行删除或者匿名化处理。您无法再检索、访问、获取、继续使用和找回，也无权要求我们找回您的个人信息，前述个人信息包括但不限于:头像、昵称、战绩、购买或游戏中获得的角色及其它虚拟物品、言论、地区、好友、聊天记录等内容。</p>
    <div class="off-remind">有关游戏账号注销的其它详细规则及注意事项请点击查看
      <a class="game-contrat"  @click="gotoProtocol">《游戏账号注销协议》</a>
    </div>
    </div>
    <div class="footer-next">
      <div @click="chosebox" class="checked" >
        <p class="check-big-box">
          <span class="check-box" :class="{chose:choseBol}" ></span>
        </p>
        <span style="font-size:13px;font-family:FZLTHK--GBK1-0">
         我已详细阅读并同意<a class="game-contrat"  @click="gotoProtocol">《游戏账号注销协议》</a>
        </span>
      </div>
      <button @click="gotomsg" class="detail-btn">下一步</button>
    </div>
  </div>
</template>
<script >

export default {
  data(){
    return {
      choseBol:false,
    }
  },
  created(){
    this.setScrolltop()
  },
  methods:{
    setScrolltop(){
      document.documentElement.scrollTop = 0 
      document.body.scrollTop = 0
      window.pageYOffset = 0;
    },
    gotoProtocol() {//
    if(this.isIOS()) {
      this.$router.push({
        path:'/protocolios'
      })
    } else {
      this.$router.push({
        path:'/protocol'
      })
    }
    },
    isIOS(){
            let u = navigator.userAgent;
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            return isiOS;
     },
    gotomsg () {
       if(!this.choseBol) {
        return alert('请勾选同意。') 
      }
      this.$router.push({
        path:"/readlogoff"
      })
    },
     chosebox (){
      this.choseBol= !this.choseBol
    }
  }
}
</script>
<style lang="scss" scoped>
.off-detail {
    background-color: #fff;
    padding:2.5rem;
    font-family:"FZLTHK--GBK1-0";
  .off-detail-main {
    height:31.25rem;
    width:100%;
    overflow-y: auto;
    .off-detail-tit {
      text-align:center;    
    }
  .off-msg {
      span{
        color: black;
        font-size: 1.125rem;
        font-weight: 900;
      }
    }
    .off-remind{
      font-size:14px;
      font-family:"FZLTHK--GBK1-0";
      margin-bottom:1.25rem;
      cursor: pointer;
      .game-contrat{
        color:blue;
        cursor: pointer;
      }
    }
  }
  .footer-next{
    box-shadow: 0 0 5px #ccc;
    position: fixed;
    bottom:.375rem;
    left:0;
    right:0;
    text-align: center;
     padding:10px;
    .checked {
      cursor: pointer;
      background:#fff;
      .check-big-box{
        display: inline-block;
        width: 0.625rem;
        height: 0.625rem;
        border-radius:0.625rem;
        border:1px solid black;
        line-height: 0.625rem;
        margin-left:.3125rem;
        text-align: center;
      .check-box{
        display: inline-block;
        width: 0.325rem;
        height: 0.325rem;
        border-radius:0.325rem;
        margin-bottom:.185rem
        }
      }
    }
    .chose{
      background: blue;
    }
    .detail-btn{
      background: #234ed0;
      border: none;
      width: 100%;
      height: 40px;
      text-align: center;
      border-radius: 20px;
      font-size: 18px;
      color: #fff;
    }
  }
}
</style>
